import fr from "./fr.json";
import en from "./en.json";
import de from "./de.json";
import nl from "./nl.json";
import es from "./es.json";
import sv from "./sv.json";

export default defineI18nConfig(() => ({
  legacy: false,
  messages: {
    fr: fr,
    en: en,
    de: de,
    nl: nl,
    es: es,
    sv: sv,
  },
  // baseUrl: url// not working from here
}));
